module.exports = __webpack_public_path__ + "static/media/7.649e55a8.jpg";